export const toggleOverlay = (hovered) => {
  if (hovered) {
    document.body.setAttribute("data-icon-overlay", "open");
  } else {
    document.body.setAttribute("data-icon-overlay", "");
  }
};

export const toggleSideBar = () => {
  const isOpen = !!localStorage?.getItem("data-toggled");

  if (!isOpen) {
    document.body.setAttribute("data-toggled", "icon-overlay-open");
    localStorage?.setItem("data-toggled", "icon-overlay-open");
  } else {
    document.body.setAttribute("data-toggled", "icon-overlay-close");
    localStorage?.removeItem("data-toggled");
  }
};
